import { render, staticRenderFns } from "./taskClaim.vue?vue&type=template&id=5a0e1183&scoped=true&"
import script from "./taskClaim.vue?vue&type=script&lang=js&"
export * from "./taskClaim.vue?vue&type=script&lang=js&"
import style0 from "./taskClaim.vue?vue&type=style&index=0&id=5a0e1183&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0e1183",
  null
  
)

export default component.exports